import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface SalesTabsConfig {
  customer_priorities: boolean;
  customer_kpis: boolean;
  business_value_framework: boolean;
  ai_sales_advisor: boolean;
}

export const useSalesTabs = () => {
  const [config, setConfig] = useState<SalesTabsConfig>({
    customer_priorities: true,
    customer_kpis: true,
    business_value_framework: true,
    ai_sales_advisor: true
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSalesTabs = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('sales_tabs')
          .select('customer_priorities, customer_kpis, business_value_framework, ai_sales_advisor')
          .limit(1)
          .single();

        if (fetchError) {
          console.error('Error fetching sales tabs:', fetchError);
          setError('Failed to fetch sales tabs configuration');
          return;
        }

        if (data) {
          setConfig({
            customer_priorities: data.customer_priorities || false,
            customer_kpis: data.customer_kpis || false,
            business_value_framework: data.business_value_framework || false,
            ai_sales_advisor: data.ai_sales_advisor || false
          });
        }
      } catch (error) {
        console.error('Error in fetchSalesTabs:', error);
        setError('Failed to fetch sales tabs configuration');
      } finally {
        setIsLoading(false);
      }
    };

    fetchSalesTabs();
  }, []);

  return { config, isLoading, error };
};